
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from './types';

interface DescriptionFieldProps {
  form: UseFormReturn<FormValues>;
  label?: string;
  placeholder?: string;
}

export const DescriptionField: React.FC<DescriptionFieldProps> = ({ 
  form,
  label = "Description",
  placeholder = "Please describe the issue or feature request in detail"
}) => {
  return (
    <FormField
      control={form.control}
      name="description"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Textarea
              placeholder={placeholder}
              className="min-h-[80px]"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
